<div class="ai-card__header d-flex align-items-start gap-2 px-3 py-2">
  <div class="d-flex flex-column flex-fill min-w-0">
    <span class="mat-font-label-md fw-semibold text-truncate" style="max-width: 165px" [matTooltip]="displayName()">{{ displayName() }}</span>
    @if (rawName()) {
    <span class="card-header__raw mat-font-label-sm">{{ rawName() }}</span>
    }
  </div>

  <div class="flex-shrink-0">
    <ng-content />
  </div>
</div>
